// test2866
(2866 && 0);
